import type { BoxProps } from "@chakra-ui/react";
import { MAX_GRID_WIDTH } from "config/styleConsts";

import { Box, SimpleGrid } from "@chakra-ui/react";

const CustomGrid = ({ children, ...props }: BoxProps) => (
  <Box width="100%" maxWidth={MAX_GRID_WIDTH} px={4} mx="auto" {...props}>
    <SimpleGrid columns={5} spacing={12}>
      {children}
    </SimpleGrid>
  </Box>
);

export default CustomGrid;
